import { render, staticRenderFns } from "./organAudit.vue?vue&type=template&id=e95dee42&scoped=true&"
import script from "./organAudit.vue?vue&type=script&lang=js&"
export * from "./organAudit.vue?vue&type=script&lang=js&"
import style0 from "./organAudit.vue?vue&type=style&index=0&id=e95dee42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95dee42",
  null
  
)

export default component.exports